import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResumeCall = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.84791 2.06472L16.3669 8.49299C16.8782 8.82171 17.207 9.40609 17.207 9.99048C17.207 10.6114 16.8782 11.1958 16.3669 11.488L5.84791 17.9163C5.30005 18.245 4.60609 18.2815 4.05822 17.9528C3.51036 17.6606 3.18164 17.0762 3.18164 16.4188V3.56221C3.18164 2.9413 3.51036 2.35691 4.05822 2.06472C4.60609 1.736 5.30005 1.736 5.84791 2.06472Z",
		fill: "currentColor"
	})
});
export default SvgResumeCall;
